import React from 'react';
import { Link } from 'react-router-dom';

const ReadMoreButton = ({ 
  to, 
  text = "Read more",
  className = "" 
}) => {
  return (
    <Link to={to}>
      <div className={`
        w-36 
        text-sm md:text-base 
        mt-4 
        px-6 
        py-2 
        border-2 
        border-gray-800 
        text-center 
        text-gray-800 
        hover:bg-gray-800 
        hover:text-white 
        transition-colors
        ${className}
      `}>
        {text}
      </div>
    </Link>
  );
};

export default ReadMoreButton;